// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary{color:#c81919}.basic--input textarea{margin-top:0 !important}.bio-example{margin-top:8px;padding:10px 12px;border:1px solid #e3e7ec;border-radius:8px;background:#f8fafc}.bio-example__title{font-family:Poppins-SemiBold,sans-serif;font-size:.9rem;color:#333;margin-bottom:6px}.bio-example__text{font-family:Poppins,sans-serif;font-size:.9rem;line-height:1.55;color:#333}.bio-example__text+.bio-example__text{margin-top:8px}", ""]);
// Exports
module.exports = exports;
